import { Component, HostBinding, Input } from '@angular/core';
import { ContentBlock } from '@tytapp/content/content-block';


@Component({
    selector: 'tyt-content-view',
    templateUrl: './content-view.component.html',
    styleUrls: ['./content-view.component.scss']
})
export class ContentViewComponent {
    @Input() blocks: ContentBlock[];
    @Input()
    @HostBinding('attr.data-mode')
    mode: 'standard' | 'split' | 'sidebar-left';

    get primaryBlocks() { return this.blocks?.filter(x => !x.secondary) ?? []; }
    get secondaryBlocks() { return this.blocks?.filter(x => x.secondary) ?? []; }

    @HostBinding('class.two-column') get singleColumn() { return this.secondaryBlocks.length > 0; }
}
